import React from 'react';
import { Box } from '@mui/material';
import { colors, fonts, size } from '../../ColorFont/color';

/**
 * BaseChip Component
 * A reusable pill component for tags/features using universal design tokens.
 */
const BaseChip = ({ label, active }) => {
    return (
        <Box
            sx={{
                backgroundColor: active ? colors.light : colors.tag_bg,
                color: colors.text,
                borderRadius: "9999px",
                padding: { xs: "2px 6px", sm: "4px 8px" },
                fontSize: { xs: "10px", sm: size.mini },
                fontFamily: fonts.poppins,
                transition: "background-color 0.3s ease",
                lineHeight: "16px",
                fontWeight: 400,
                whiteSpace: "nowrap",
            }}
        >
            {label}
        </Box>
    );
};

export default BaseChip;
